import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {getFormattedAmount} from '../../../../common/utils'
import {PammOfferType} from '../../../../graphql/types'
import {
  mapIntervalNameToI18nKeyPlural,
  mapIntervalNameToI18nKeySingular,
} from '../../../Accounts/PammManagerSettingsView/components/PammManagerOffers/components/OfferTile'
import {
  Amount,
  GreenAmount,
} from '../../../Accounts/PammManagerSettingsView/components/PammManagerOffers/components/OfferTile/components/GreenAmount'
import {LargeText} from '../../../Accounts/PammManagerSettingsView/components/PammManagerOffers/components/OfferTile/components/OfferBody/components/LargeText'
import {Column} from '../Column'
import {Label} from '../Label'
import {Row} from '../Row'
import {VerticalSpace} from '../VerticalSpace'

type ConditionsProps = {
  offer: PammOfferType
}

export const Conditions = ({offer}: ConditionsProps) => (
  <Row>
    <Column>
      <Label>
        <Trans {...messages.tradingInterval} />
      </Label>
      <LargeText>
        {offer.settings?.tradingInterval?.count}{' '}
        <Trans
          {...(offer.settings?.tradingInterval?.count === 1
            ? mapIntervalNameToI18nKeySingular
            : mapIntervalNameToI18nKeyPlural)[
            offer.settings?.tradingInterval?.type ?? 'CalendarMonths'
          ]}
        />
      </LargeText>
      <VerticalSpace />
      <Label>
        <Trans {...messages.minWithdrawal} />
      </Label>
      <Amount>
        {getFormattedAmount({amount: offer.settings?.minWithdrawal, currency: offer.currency})}
      </Amount>
    </Column>
    <Column>
      <Label>
        <Trans {...messages.minDeposit} />
      </Label>
      <GreenAmount>
        {getFormattedAmount({amount: offer.settings?.minDeposit, currency: offer.currency})}
      </GreenAmount>
      <VerticalSpace />
      <Label>
        <Trans {...messages.minInitialInvestment} />
      </Label>
      <GreenAmount>
        {getFormattedAmount({
          amount: offer.settings?.minInitialInvestment,
          currency: offer.currency,
        })}
      </GreenAmount>
    </Column>
  </Row>
)
